import CorrelationField from "../CorrelationField/BaseCorrelationField"
import { readDataByContentItemIds } from "../../../apis/httpHelper";
import { singleDataConvert } from "../../../common/commonHelper";

export default {
    mixins:[CorrelationField],
    methods:{
        getAllData:function(){
            if(!this.selfSetting.IsShowValue){
                return;
            }
            if(this.data[this.name] == undefined || this.data[this.name] == null){
                return;
            }
            else if(Array.from(this.data[this.name]).length == 0){
                return;
            }
            else{
                readDataByContentItemIds(Array.from(this.data[this.name]), this.displayFields,true)
                    .then(x=>{
                        let fields = x.Result.fieldDefitions;
                        x.Result.data.forEach(dataItem=> {
                            fields.forEach(field=>{
                                dataItem[field.Name] = singleDataConvert(dataItem[field.Name], field.Type);
                            })
                        })
                        this.selectItems = x.Result.data;
                    })
            }
        },

        sumbit:function(){
            let selectItemContentIds = this.gridSelectItems.map(x=>x.ContentItemId);
            let result = Array.from(new Set((this.data[this.name] || []).concat(selectItemContentIds)));
            this.data[this.name] = result;
            this.getAllData();
            this.gridState = false;
        },

        deleteItem:function(id){
            let index = (this.data[this.name] || []).findIndex(x=>x ==  id);
            (this.data[this.name] || []).splice(index, 1);
            let selectIndex = this.selectItems.findIndex(x=>x.ContentItemId == id);
            this.selectItems.splice(selectIndex, 1);
        },
    }
}